<template lang='pug' src='./modal.pug'></template>

<script>
import ModalContact from 'components/custom/custom-modal-contact/custom-modal-contact'
import ModalRefer from 'components/custom/custom-modal-refer/custom-modal-refer'
import ModalInfographic from 'components/custom/custom-modal-infographic/custom-modal-infographic'
import ModalLearn from 'components/custom/custom-modal-learn/custom-modal-learn'
import ModalSurvey from 'components/custom/custom-modal-survey/custom-modal-survey'
import ModalThank from 'components/custom/custom-modal-thank/custom-modal-thank'
import ModalTeam from 'components/custom/custom-modal-team/custom-modal-team'
import { closeModal } from 'components/mixins'

export default {
  computed: {
    props () {
      return this.$store.state.app.modal
    }
  },
  mixins: [closeModal],
  components: {
    ModalContact,
    ModalRefer,
    ModalInfographic,
    ModalLearn,
    ModalSurvey,
    ModalThank,
    ModalTeam
  }
}
</script>



// WEBPACK FOOTER //
// modal.vue?0c34e47a